import _classCallCheck from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createClass";
import _inherits from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/inherits";
import _createSuper from "D:/workspace/js/hotfix/sunway-web-ui/node_modules/@babel/runtime/helpers/esm/createSuper";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.array.fill.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.array.splice.js";
import Gikam from '../../../core/gikam-core';
import tab from '../vue/tab.vue';
import Vue from 'vue';
import Base from '../../base';
var defaultOptions = {
  renderTo: void 0,
  showIndex: 0,
  // 组件高度，支持百分数、数字、像素字符串
  height: 'auto',
  panels: [],
  panelsShowNum: null,
  show: true,
  // 允许的最大宽度，由父组件传值
  allowWidth: 0,
  // 是否填充满父容器
  fill: false,
  // 自定义tab样式
  style: void 0,
  // 是否显示收缩icon
  shrink: true,
  // 是否展开
  expand: true,
  // 是否显示边框
  bordered: true,
  // 折叠事件
  onToggle: null,
  // 面板切换事件，如果返回true允许切换，返回false不允许切换
  onBeforePanelSwitch: null,
  // 面板切换时是否开启动画
  panelSwitchAnimate: true
};

var Tab = /*#__PURE__*/function (_Base) {
  _inherits(Tab, _Base);

  var _super = _createSuper(Tab);

  function Tab(props) {
    var _this;

    _classCallCheck(this, Tab);

    _this = _super.call(this, 'Tab');
    _this.listeners = {
      rendered: Gikam.emptyFunction,
      actived: Gikam.emptyFunction
    };

    _this.initialize(props, defaultOptions).init(props);

    return _this;
  }

  _createClass(Tab, [{
    key: "createModel",
    value: function createModel() {
      var _this2 = this;

      var h = this.$createElement;
      var options = this.options;
      this.model = new Vue({
        el: Gikam.createDom('div', this.options.renderTo),
        provide: {
          tab: this
        },
        data: function data() {
          return {
            options: options
          };
        },
        render: function render() {
          var h = arguments[0];
          return h(tab, {
            "ref": "vm",
            "attrs": {
              "options": this.options
            }
          });
        }
      });
      this.model.$nextTick(function () {
        _this2.trigger('rendered');
      });
    }
  }, {
    key: "createItems",
    value: function createItems() {
      var _this3 = this;

      var panelBodyList = this.model.$refs.vm.$refs.panelBody;
      this.options.panels.forEach(function (tabPaneItem, index) {
        if (!tabPaneItem.items) {
          tabPaneItem.items = [];
        } //只有一个子元素时，如果标签页是填充模式或者设置了高度，那么子元素为填充模式


        if (tabPaneItem.items.length === 1 && (_this3.options.fill === true || _this3.options.height && _this3.options.height !== 'auto')) {
          tabPaneItem.items[0].fill = true;
        }

        tabPaneItem.items.forEach(function (item) {
          item.renderTo = panelBodyList[index];
          item.$window = _this3.$window;
          item.$parent = _this3;
          item.$title = tabPaneItem.title;
          item.allowWidth = _this3.options.allowWidth || _this3.options.renderTo.clientWidth;
          Gikam.create(item.type, item);
        });
      });
    }
  }, {
    key: "show",
    value: function show() {
      this.model.$refs.vm.show = true;
    }
  }, {
    key: "hide",
    value: function hide() {
      this.model.$refs.vm.show = false;
    }
  }, {
    key: "removePanel",
    value: function removePanel(id) {
      this.model.$refs.vm.removePanel(id);
    }
  }, {
    key: "revertPanel",
    value: function revertPanel(id) {
      this.model.$refs.vm.revertPanel(id);
    }
  }, {
    key: "showPanel",
    value: function showPanel(id) {
      this.model.$refs.vm.showPanel(id);
    }
    /**
     * @description 替换tab内的panels
     * @param {Array} panels  新的数组
     * @memberof Tab
     * @public
     */

  }, {
    key: "refreshPanels",
    value: function refreshPanels(panels) {
      var _this4 = this;

      if (panels instanceof Array === false) {
        return Gikam.error('parameter type must be array');
      }

      this.options.panels = panels;
      this.model.$nextTick().then(function () {
        var _this4$model$$refs$vm = _this4.model.$refs.vm,
            showIndex = _this4$model$$refs$vm.showIndex,
            switchPanel = _this4$model$$refs$vm.switchPanel,
            switchTabIndex = _this4$model$$refs$vm.switchTabIndex,
            initTabBtn = _this4$model$$refs$vm.initTabBtn; //处理激活的panels

        if (panels.length - 1 < showIndex) {
          switchPanel(0);
          switchTabIndex(0);
        }

        initTabBtn();
        var panelBodyList = _this4.model.$refs.vm.$refs.panelBody;
        panelBodyList.forEach(function (panelDom) {
          panelDom.innerHTML = '';
        });

        _this4.createItems();
      });
    }
    /**
     * @description 根据每页的id 修改右上角角标数量
     * @public
     * @param {String} panelId 需要修改的页码id
     * @param {Number} badge   需要添加的数量
     * @returns Tab
     * @memberof Tab
     */

  }, {
    key: "setPanelBadge",
    value: function setPanelBadge(panelId, badge) {
      if (typeof panelId !== 'string' || typeof badge !== 'number') {
        return;
      }

      this.model.$refs.vm.setPanelBadge(panelId, badge);
      return this;
    }
    /**
     * @description 向panel中追加组件参数
     * @public
     * @param {String} id panelId
     * @param {Array} items   需要添加的组件参数
     * @returns Tab
     * @memberof Tab
     */

  }, {
    key: "appendItems",
    value: function appendItems(id, items) {
      var _this5 = this;

      var _index = -1;

      Gikam.each(this.options.panels, function (index, panel) {
        if (panel.id === id) {
          _index = index;
        }
      });

      if (_index === -1) {
        return Gikam.error('该tab上未找到对应panel');
      }

      var panelBodyList = this.getPanelDomList();

      if (panelBodyList === false) {
        return;
      }

      this.options.panels[_index].items.concat(items);

      items.forEach(function (item) {
        item.renderTo = panelBodyList[_index];
        item.$window = _this5.$window;
        item.$parent = _this5;
        item.allowWidth = _this5.options.allowWidth || _this5.options.renderTo.clientWidth;
        Gikam.create(item.type, item);
      });
    }
    /**
     * @description 清空panel中的内容
     * @public
     */

  }, {
    key: "cleanItems",
    value: function cleanItems(id) {
      var _index = -1;

      Gikam.each(this.options.panels, function (index, panel) {
        if (panel.id === id) {
          _index = index;
        }
      });

      if (_index === -1) {
        return Gikam.error('该tab上未找到对应panel');
      }

      this.options.panels[_index].items = [];
      var panelList = this.getPanelDomList();

      if (Gikam.isNotEmpty(panelList)) {
        panelList[_index].innerHTML = '';
      }
    }
    /**
     * @description 获取panel的dom集合
     * @private
     */

  }, {
    key: "getPanelDomList",
    value: function getPanelDomList() {
      if (Gikam.isEmpty(this.model.$refs.vm)) {
        return false;
      }

      if (Gikam.isEmpty(this.model.$refs.vm.$refs.panelBody)) {
        return false;
      }

      return this.model.$refs.vm.$refs.panelBody;
    }
    /**
     * @description 设置panels 的id
     * @private
     */

  }, {
    key: "formatterPanels",
    value: function formatterPanels() {
      var _this6 = this;

      var panels = this.options.panels;

      var _loop = function _loop(i) {
        var panel = panels[i];

        if (!panel.id) {
          panel.id = panel.title;
        } // 页面配置


        if (_this6.options.pageEditPanels) {
          var configPanel = _this6.options.pageEditPanels.find(function (configPanel) {
            return configPanel.id === panel.id;
          });

          Object.assign(panel, configPanel);

          if (Gikam.loginUser) {
            if (Gikam.loginUser.isAdmin || Gikam.isEmpty(configPanel.visibleRoles)) {
              return "continue";
            }

            if (configPanel.visibleRoles.every(function (roleId) {
              return !Gikam.loginUser.roles.includes(roleId);
            })) {
              _this6.options.panels.splice(i, 1);
            }
          }
        }
      };

      for (var i = panels.length - 1; i > -1; i--) {
        var _ret = _loop(i);

        if (_ret === "continue") continue;
      }
    }
  }, {
    key: "init",
    value: function init() {
      this.formatterPanels();
      this.createModel();
      this.bindInstance(this.model.$el);
      this.createItems();
    }
    /**
     * @description
     * @returns
     * @memberof Tab
     */

  }, {
    key: "getPageEditorOptions",
    value: function getPageEditorOptions() {
      var options = Gikam.deepExtend(this.options);
      options.panels.forEach(function (panel) {
        return delete panel.items;
      });
      return {
        pageEditPanels: options.panels
      };
    }
  }, {
    key: "setDefaultOptions",
    value: function setDefaultOptions(options) {
      Gikam.extend(true, defaultOptions, options.defaultOptions);
    }
  }]);

  return Tab;
}(Base);

export { Tab as default };